import { defineComponent, h } from 'vue';
import { formatStyleVars } from '../utils/elements';
export default defineComponent({
  name: 'VarStyleProvider',
  props: {
    styleVars: {
      type: Object,
      default: () => ({})
    }
  },

  setup(props, _ref) {
    var {
      slots
    } = _ref;
    return () => h('div', {
      class: 'var-style-provider',
      style: formatStyleVars(props.styleVars)
    }, slots.default == null ? void 0 : slots.default());
  }

});